export function getAriaControlsElement(element: HTMLElement) {
  return getElementById(element.getAttribute("aria-controls"));
}

export function getAriaControlsElements(element: HTMLElement) {
  return getElementsById(element.getAttribute("aria-controls"));
}

export function getAriaExpanded(element: HTMLElement) {
  return getBooleanAttribute(element, "aria-expanded");
}

export function setAriaExpanded(
  element: HTMLElement,
  value: boolean | undefined,
) {
  setBooleanAttribute(element, "aria-expanded", value);
}

export function getAriaSelected(element: HTMLElement) {
  return getBooleanAttribute(element, "aria-selected");
}

export function setAriaSelected(
  element: HTMLElement,
  value: boolean | undefined,
) {
  setBooleanAttribute(element, "aria-selected", value);
}

function getElementById(idList: string | undefined | null) {
  if (typeof idList !== "string") {
    return undefined;
  }

  let index = idList.indexOf(" ");
  if (index === -1) {
    index = idList.length;
  }

  const id = idList.substring(0, index);
  const element = document.getElementById(id);
  if (!element) {
    return undefined;
  }

  return element;
}

function* getElementsById(idList: string | undefined | null) {
  if (typeof idList !== "string") {
    return;
  }

  for (const id of idList.split(" ")) {
    const element = document.getElementById(id);
    if (element) {
      yield element;
    }
  }
}

function getBooleanAttribute(element: HTMLElement, name: string) {
  const value = element.getAttribute(name);
  if (typeof value === "string") {
    return value === "true" || value === "TRUE";
  } else {
    return undefined;
  }
}

function setBooleanAttribute(
  element: HTMLElement,
  name: string,
  value: boolean | undefined,
) {
  if (typeof value === "boolean") {
    element.setAttribute(name, value ? "true" : "false");
  } else {
    element.removeAttribute(name);
  }
}
